import Backtop from './src/backtop'
export default Backtop


// WEBPACK FOOTER //
// ./src/components/backtop/index.js